import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';

const MentionsLegalesPage = () => {
  return (
    <>
      <SEO
        title="Mentions légales — CarMaintenance"
        description="Informations légales relatives à Car Maintenance Sàrl, éditeur du site CarMaintenance : siège à Châtelaine (Genève), IDE CHE-242.701.440, hébergement Infomaniak."
        path="/mentions-legales"
      />
      <PageHero
        title="Mentions légales"
        subtitle="Informations légales relatives à l'éditeur du site"
      />
      <div className="bg-gradient-to-b from-gray-50 to-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">

          <Card>
            <CardContent className="p-6 space-y-6">
            {/* Identité de l'éditeur */}
            <section>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Éditeur du site</h3>
              <p className="font-semibold text-gray-900">Car Maintenance Sàrl</p>
              <p className="text-gray-700">Square des Nénuphars 4</p>
              <p className="text-gray-700">1219 Châtelaine</p>
              <p className="text-gray-700">GE, Suisse</p>
              <p className="text-gray-700 mt-3"><strong>Téléphone :</strong> 022 980 93 93</p>
              <p className="text-gray-700">
                <strong>E-mail :</strong>{' '}
                <a href="mailto:info@car-main.ch" className="text-[#52a675] hover:underline">
                  info@car-main.ch
                </a>
              </p>
            </section>

            {/* Direction / Gérance */}
            <section className="pt-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Direction</h3>
              <p className="text-gray-700"><strong>Gérant :</strong> Duraku Dionis</p>
            </section>

            {/* Données légales */}
            <section className="pt-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Informations légales</h3>
              <p className="text-gray-700"><strong>Forme juridique :</strong> Société à responsabilité limitée (Sàrl)</p>
              <p className="text-gray-700"><strong>Capital social :</strong> CHF 20'000</p>
              <p className="text-gray-700">
                <strong>Registre du commerce :</strong> inscrit au Registre du commerce du canton de Genève
              </p>
              <p className="text-gray-700"><strong>Numéro IDE :</strong> CHE-242.701.440</p>
              <p className="text-gray-700"><strong>Numéro TVA :</strong> CHE-242.701.440 TVA</p>
            </section>

            {/* Hébergement */}
            <section className="pt-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Hébergement</h3>
              <p className="text-gray-700">
                Ce site est hébergé par <strong>Infomaniak Network SA</strong>, Rue Eugène-Marziano 25, 1227 Les Acacias, Suisse.
              </p>
            </section>

            {/* Propriété intellectuelle */}
            <section className="pt-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Propriété intellectuelle</h3>
              <p className="text-gray-700">
                Le contenu de ce site (textes, images, logo, vidéos, code source) est protégé par le droit d'auteur et demeure la propriété exclusive de Car Maintenance Sàrl, sauf indication contraire. Toute reproduction, distribution ou utilisation non autorisée du contenu est strictement interdite.
              </p>
            </section>

            {/* Liens externes */}
            <section className="pt-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Liens externes</h3>
              <p className="text-gray-700">
                Ce site peut contenir des liens vers des sites tiers. Nous n'assumons aucune responsabilité quant au contenu, à la disponibilité ou à la politique de confidentialité de ces sites externes.
              </p>
            </section>

            {/* Responsabilité */}
            <section className="pt-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Responsabilité</h3>
              <p className="text-gray-700">
                Nous nous efforçons de fournir des informations précises et à jour. Toutefois, nous ne pouvons garantir l'exactitude et l'exhaustivité du contenu. Nous déclinons toute responsabilité en cas de dommages directs ou indirects résultant de l'utilisation de ce site.
              </p>
            </section>

            {/* Juridiction */}
            <section className="pt-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Juridiction</h3>
              <p className="text-gray-700">
                Tout litige relatif à l'utilisation de ce site est régi par le droit suisse et relève de la compétence exclusive des tribunaux du canton de Genève.
              </p>
            </section>

            {/* Cross-link Protection des données */}
            <div className="pt-4 border-t border-gray-200 text-gray-700">
              Pour le traitement de vos données personnelles, consultez notre{' '}
              <Link to="/protection-donnees" className="text-[#52a675] hover:underline font-medium">
                Politique de protection des données
              </Link>
              .
            </div>
          </CardContent>
        </Card>
        </div>
      </div>
    </>
  );
};

export default MentionsLegalesPage;
